import { useContext, useMemo } from 'react';

import './styles.scss';
import PricingGroup from '../../../../components/pricing-group';
import Select from '../../../../components/select/select';
import { PricingContext } from '../../../../providers/pricing-provider';

const CALIBRATION_FIELDS = ['xi', 'rho', 'vol_0'];

const PricingDataAnalytics = () => {
  const { trades, getTradeResult } = useContext(PricingContext);

  const formatValue = (value: any): string => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'number') {
      return value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 6,
      });
    }
    return String(value);
  };

  const getCalibrationFields = useMemo(() => {
    const fieldsSet = new Set<string>();
    trades.forEach((trade) => {
      const result = getTradeResult(trade.id);
      if (result?.calibration?.display) {
        CALIBRATION_FIELDS.forEach((field) => {
          if (result.calibration.display[field] !== undefined) {
            fieldsSet.add(field);
          }
        });
      }
    });
    return CALIBRATION_FIELDS.filter((field) => fieldsSet.has(field));
  }, [trades, getTradeResult]);

  const getSmileModel = (tradeId: string): string => {
    const result = getTradeResult(tradeId);
    return result?.calibration?.smile_model || '-';
  };

  const getCalibrationValue = (tradeId: string, key: string): string => {
    const result = getTradeResult(tradeId);
    return formatValue(result?.calibration?.display?.[key]);
  };

  const formatFieldLabel = (key: string): string => {
    if (key === 'xi') return 'Xi';
    if (key === 'rho') return 'Rho';
    return key;
  };

  return (
    <div className="pricing-data">
      <PricingGroup label={'Market data Analytics'} isClosable defaultOpen={true}>
        <div className="content-header">
          <div className="content-header-items">
            <div className="content-header-items-fixed">Smile interpolation</div>
            {trades.map((trade) => (
              <div className="content-header-items-trade" key={trade.id}>
                <Select
                  values={[{ name: getSmileModel(trade.id), value: getSmileModel(trade.id) }]}
                  defaultValue={{ name: getSmileModel(trade.id), value: getSmileModel(trade.id) }}
                  onChange={() => {}}
                  className="select-header"
                />
              </div>
            ))}
            <div className="content-header-items-trade"></div>
          </div>
        </div>
        <div className="pricing-data-container">
          <div className="fixed-panel">
            {getCalibrationFields.map((field) => (
              <span className="item" key={field}>
                &nbsp;
              </span>
            ))}
          </div>
          <div className="content-panel">
            {trades.map((trade) => (
              <div key={trade.id} className="block">
                {getCalibrationFields.map((field) => (
                  <div className="item-row" key={field}>
                    <span className="item-content no-border">{formatFieldLabel(field)}</span>
                    <span className="item-content">{getCalibrationValue(trade.id, field)}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </PricingGroup>
    </div>
  );
};

export default PricingDataAnalytics;
